<template>
  <v-app-bar
    app
    dark
    height="55"
    class="nav-bar-primary-color"
  >
    <div 
    class="d-flex align-center">
      <infinite-loader
      v-if="loading"
      color="white"
      size="30"/>
      <label
      v-else
      class="nav-bar-title">
        {{$t('pages.contact.helloUser', {'0': `${getContact.firstName} ${getContact.lastName}`})}}
      </label>
    </div>
    <navigator-bar-for-admin v-if="isAdmin || isSuperAdmin"/>
    <navigator-bar-for-supervisor v-else-if="isSupervisor"/>
    <navigator-bar-for-service v-else-if="isService"/>
    <navigator-bar-for-client v-else-if="isClient"/>
    <navigator-bar-for-sus-manager v-else-if="isSM"/>
  </v-app-bar>
</template>
<script>
import InfiniteLoader from '@/components/common/InfiniteLoader'
import NavigatorBarForAdmin from '@/components/navigation/NavigatorBarForAdmin'
import NavigatorBarForSupervisor from '@/components/navigation/NavigatorBarForSupervisor'
import NavigatorBarForService from '@/components/navigation/NavigatorBarForService'
import NavigatorBarForClient from '@/components/navigation/NavigatorBarForClient'
import NavigatorBarForSusManager from '@/components/navigation/NavigatorBarForSusManager'
import { DynamicNotifier } from '@/utils/DynamicNotifier.js'
import { execHttpRequestThrowable } from '@/services/http'
import { getUserRole, getUserIdentification } from '@/services/authService'
import { fetchContact } from '@/repositories/contactRepo'
export default {
  components: {
    InfiniteLoader,
    NavigatorBarForAdmin,
    NavigatorBarForSupervisor,
    NavigatorBarForService,
    NavigatorBarForClient,
    NavigatorBarForSusManager
  },
  data() {
    return {
      identificationNotifier: null,
      numberOfActionRequiredAllRequestsIntervalId: null,
      loading: false
    }
  },
  computed: {
    getUsername() {
      if (this.identificationNotifier && this.identificationNotifier.static != this.identificationNotifier.dynamic) {
        DynamicNotifier.reset(this.identificationNotifier)
        return getUserIdentification()
      }
      else return ''
    },
    isSuperAdmin() {
      return this.getRole === "SUPER_ADMIN"
    },
    isAdmin() {
      return this.getRole === "ADMIN"
    },
    isSupervisor() {
      return this.getRole === "SUPERVISOR"
    },
    isService() {
      return this.getRole === "SERVICE"
    },
    isClient() {
      return this.getRole === "CLIENT"
    },
    isSM() {
      return this.getRole === "SUSTAINABILITY_MANAGER"
    },
    getRole() {
      return getUserRole()
    },
    getContact() {
      return this.$contactHolder.get()
    }
  },
  methods: {
    async tryToFetchContactData() {
      this.loading = true
      const r = await execHttpRequestThrowable(fetchContact)
      this.$contactHolder.set(r.response.data)
      DynamicNotifier.notify('contactEvent')
      this.loading = false
    },
    isRole(role) {
      return role === this.getRole
    },
  },
  async mounted() {
    this.identificationNotifier = DynamicNotifier.request('usernameEvent')

    if (!this.isAdmin && !this.isSuperAdmin && !this.isSM) {
      this.numberOfActionRequiredAllRequestsIntervalId = this.$actionRequired.startFetching()

      await this.$actionRequired.fetch()
    }
    await this.tryToFetchContactData()
  },
  beforeDestroy() {
    if (this.identificationNotifier) DynamicNotifier.delete(this.identificationNotifier, 'usernameEvent')
    if (this.numberOfActionRequiredAllRequestsIntervalId) clearInterval(this.numberOfActionRequiredAllRequestsIntervalId)
    this.$actionRequired.clearAll()
  }
}
</script>
<style>
.nav-bar-primary-color {
  background-color: #0d47a1!important;
}
.nav-bar-title {
  font-family: 'Titillium Web', sans-serif;
  font-size: 1.25rem;
  line-height: inherit;
  letter-spacing: 1px;
  font-weight: 300;
}
.nav-bar-group-btn-side-line {
  width: 2px;
  background: #83a4d6; 
  height: 20px; 
  border-radius: 80px;
}
</style>